<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
    </div>
    <section v-menu-permission="'edit'" class="app-content">
      <div class="card">
        <div class="card-body">
          <em-entity-edit-form ref="emEntityEditForm" :$_em-custom-vuex-mixin_entity="entityState"
                               :entity="modelName"></em-entity-edit-form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Author Liu Cui Cui
// Date 2023-07-06 16:22:17

import emCommonEditMixin from "@/mixin/em/common/edit";

export default {
  name: "sithMesMstMaterialDrawingEditView",
  mixins: [emCommonEditMixin],
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    entityState() {
      return this.$route.query.hasOwnProperty('entityState') ? this.$route.query.entityState : 'entity';
    }
  }
};
</script>